import { useAuthStore } from "@/store/auth";
import Payments from "./payments";
import invoices from "./invoices";
import yearRoute from "./yearRoute";
import staffRoute from "./staffRoute";
import rolesRoute from "./rolesRoute";
import userRoute from "./userRoute";
import transactionRoute from "./transactionRoute";
import zonaldoRoute from "./zonaldoRoute";
import lgadoRoute from "./lgadoRoute";
import directorRoute from "./directorRoute";
import institutionRoute from "./institutionRoute";
import mesRoute from "./mesRoute";
import FormRoute from "./formRoute";
import consentRoute from "./consentRoute";
export default [
  ...Payments,
  ...invoices,
  ...yearRoute,
  ...staffRoute,
  ...rolesRoute,
  ...userRoute,
  ...transactionRoute,
  ...zonaldoRoute,
  ...lgadoRoute,
  ...directorRoute,
  ...institutionRoute,
  ...mesRoute,
  ...FormRoute,
  ...consentRoute,
  {
    path: "/",
    name: "login",
    component: () => import("../views/auth/login.vue"),
    meta: {
      title: "Login",
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (useAuthStore().isLoggedIn) {
      //     // Redirect to the home page instead
      //     next({ name: "dashboard" });
      //   } else {
      //     // Continue to the login page
      //     next();
      //   }
      // },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/auth/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "dashboard" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/auth/reset-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (useAuthStore().isLoggedIn) {
          // Redirect to the home page instead
          next({ name: "dashboard" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/pEG8A1krFX",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   next({name: "dashboard" });
      // },
    },
    component: () => import("../views/dashboard/dashboard"),
  },
  {
    path: "/pEG8A1krFXy609..",
    name: "reset-password",
    meta: {
      title: "Reset Password",
      authRequired: true,
    },
    component: () => import("../views/auth/reset-password.vue"),
  },
  {
    path: "/cgvzl96QFylVYK3U",
    name: "account-dash",
    meta: {
      title: "Account Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/dash.vue"),
  },
  {
    path: "/cgvzl96QF9zV1ylVYK3U",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        next({ name: "dashboard" });
        // Continue to the login page
      },
    },
    component: () => import("../views/dashboard/default.vue"),
  },
  {
    path: "/XmyeVqbZfhIdxAqw78QX/:menu",
    name: "menu",
    meta: {
      title: "Menu List",
      authRequired: true,
      // acc: "admin",
    },
    component: () => import("../views/settings/menu-list"),
  },
  {
    path: "/ZfhIdxA",
    name: "account-dashboard",
    meta: {
      title: "Account Dashboard",
      authRequired: true,
      acc: ["y93422"],
    },
    component: () => import("../views/dashboard/account/account-dashboard.vue"),
  },

  {
    path: "/ngihfnefywu09nrr8wrr",
    name: "appInfo",
    meta: {
      title: "Update Application Information",
      authRequired: true,
      acc: ["y53416"],
    },
    component: () => import("../views/settings/appInfo/new.vue"),
  },

  {
    path: "/notfound",
    name: "notfound",
    meta: {
      title: "404",
      //
    },
    component: () => import("../views/notfound/404-cover"),
  },
  // start of import
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: {
      title: "404",
      //
    },
    component: () => import("../views/notfound/404-cover"),
  },
  // end of import
];
